var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class TextClamp extends Component {
    constructor() {
        super('TextClamp', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $(window).on('resize', () => this.initializeClampedText());
            $('#btn-toggle-clamped-text').on('click', (event) => {
                event.preventDefault();
                $('#btn-toggle-clamped-text, .text-to-clamp').toggleClass('is-expanded');
            });
            this.initializeClampedText();
            setTimeout(() => this.initializeClampedText(), 3000);
            this.success();
        });
    }
    initializeClampedText() {
        const textToClamp = $('.text-to-clamp');
        if (textToClamp.length === 0)
            return;
        $('#btn-toggle-clamped-text').addClass('d-none').removeClass('d-inline-block');
        textToClamp.removeClass('text-clamped');
        const thumbnail = $('.page-thumbnail');
        const thumbnailHeight = thumbnail.height();
        const titleHeight = $('.page h1').height() + parseInt($('.page h1').css('margin-bottom'));
        const textToClampHeight = textToClamp.height();
        console.log(textToClampHeight);
        if (thumbnail.position().y + thumbnailHeight < textToClamp.position().y + textToClampHeight - titleHeight) {
            const lineHeight = parseFloat(textToClamp.css('line-height'));
            textToClamp.css({
                '--clamped-lines': Math.ceil((thumbnailHeight - titleHeight) / lineHeight) - 2,
                '--expanded-lines': Math.ceil(textToClampHeight / lineHeight) + 1,
            }).addClass('text-clamped');
            $('#btn-toggle-clamped-text').removeClass('d-none').addClass('d-inline-block');
        }
    }
}
